<template>
  <section class="v-editor-container">
    <div :id="id"></div>
    <!-- <v-button @click="onSave">Save</v-button> -->
  </section>
</template>

<script>
import { uploadNewsImage } from '@/api/news'
import EditorJS from '@editorjs/editorjs'
const Header = require('@editorjs/header')
const SimpleImage = require('@editorjs/simple-image')
const Quote = require('@editorjs/quote')
const Marker = require('@editorjs/marker')
const LinkTool = require('@editorjs/link')
const Delimiter = require('@editorjs/delimiter')
const Warning = require('@editorjs/warning')
const RawTool = require('@editorjs/raw')
import TableWithoutSanitize from '@/utils/editor-table'
import ImageTool from '@editorjs/image'
import List from '@editorjs/list'
import Embed from '@editorjs/embed'
import Underline from '@editorjs/underline'

export default {
  name: 'VEditor',
  props: {
    id: {
      type: String,
      default: 'editorjs'
    },
    otherData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editor: null,
      isEditorReady: false,
      pendingData: null // 添加等待渲染的数据
    }
  },
  mounted() {
    this.editor = new EditorJS({
      readOnly: false,
      /**
       * Create a holder for the Editor and pass its ID
       */
      holder : this.id,
      tools: {
        header: {
          class: Header,
        },
        quote: {
          class: Quote,
          inlineToolbar: true,
        },
        Marker: {
          class: Marker
        },
        delimiter: Delimiter,
        warning: Warning,
        list: {
          class: List,
          inlineToolbar: true,
        },
        table: {
          class: TableWithoutSanitize,
          inlineToolbar: true,
          config: {
            rows: 2,
            cols: 3,
          },
        },
        // image: SimpleImage,
        image: {
          class: ImageTool,
          config: {
            uploader: {
              uploadByFile(file) {
                const params = new FormData()
                params.append('file', file)
                params.append('type', 2)
                return uploadNewsImage(params).then((res) => {
                  const { data } = res
                  const { url } = data
                  return {
                    success: 1,
                    file: {
                      url
                    }
                  }
                })
              }
            }
          }
        },
        embed: {
          class: Embed,
          // inlineToolbar: true,
          config: {
            services: {
              youtube: true,
              // coub: true
            }
          }
        },
        raw: RawTool,
        underline: Underline
      },
      /**
       * Previously saved data that should be rendered
       */
      data: {},
      onReady: () => {
        this.isEditorReady = true
        console.log('Editor.js is ready to work!')
        if (this.pendingData) {
          this.renderData(this.pendingData)
          this.pendingData = null
        }
        // new Undo({
        //   'editor': this.editor
        // })
      }
    })
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    // onSave() {
    //   this.editor.save().then(data => {
    //     console.log(data)
    //   })
    // },
    showErrorDialog(renderError){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        confirmBtn:'OK',
        isGreen:true,
        message: 'Please contact the technical team for support!',
        message2:renderError
      }).then(()=>{

      }).catch(()=>{
      })
    },
    renderData(data) {
      try {
        console.log(data, 'blob content')
        const params = JSON.parse(data)
        const { blocks } = params
        if(blocks && blocks.length > 0) {
          try {
            this.editor.render(params)
          } catch (renderError) {
            this.showErrorDialog(renderError)
            console.error('Editor render error:', renderError)
          }
        }
      } catch(e) {
        // 处理旧文本数据
        if(data) {
          try {
            this.editor.render({
              'blocks': [
                {
                  type: 'raw',
                  data: {
                    html: data
                  }
                }
              ]
            })
          } catch (rawRenderError) {
            this.showErrorDialog(rawRenderError)
            console.error('Raw render error:', rawRenderError)
          }
        }
        console.log('Data parsing error:', e)
      }
    },
    initData(data) {
      this.$nextTick(() => {
        if (this.isEditorReady && this.editor) {
          // 编辑器已就绪，直接渲染
          this.renderData(data)
        } else {
          // 编辑器未就绪，保存数据等待就绪
          this.pendingData = data
        }
      })
    },
    async handlerSave() {
      // if (!this.editor) {
      //   console.log('Editor not initialized')
      //   return
      // }
      await this.editor.save().then(data => {
        console.log(data)
        this.$emit('save', {
          data: JSON.stringify(data),
          otherData: this.otherData
        })
      })
    }
  }
}
</script>

<style lang="scss">
.v-editor-container {
    position: relative;
    width: 100%;
    min-height: 100%;
    & > div:first-child {  
        width: 100%;
        min-height: 100%;
        background: white;
        border: 1px solid #ccc;
        .codex-editor, .codex-editor__redactor {
            width: 100%;
            min-height: 100%;
        }
    }  
}
</style>